import { Button as MuiButton } from '@mui/material';

export const Button = ({ children, onClick, type = 'button', disabled = false, variant="text" }) => {
  return (
    <MuiButton onClick={() => onClick?.()} variant={variant} type={type} disabled={disabled}>
      {children}
    </MuiButton>
  );
};
